import React, { useEffect, useState } from "react";
import sampleUser from "../../../../../assets/default/user.png";
import { BiEdit } from "react-icons/bi";
import { BsThreeDotsVertical } from "react-icons/bs";
import { axios } from "../../../../../Global";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import { CiEdit } from "react-icons/ci";
import { CgSpinner } from "react-icons/cg";
import nodeinstance from "../../../../../nodeInstance";

export default function Overview({
  projectDetails = {},
  projectTypeArray = [],
  reportingManagerArray = [],
  projectCoordinatorArray = [],
  toggleProjectUpdate,
}) {
  console.log(reportingManagerArray);
  console.log(projectCoordinatorArray);
  console.log("..........d.d.d.d..d.d.d",projectDetails)
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [initialState, setIntialState] = useState({
    projectName: null,
    projectType: null,
    projectCoordinator: null,
    reportingManager: null,
  });
  // const [currentStatus, setCurrentStatus] = useState(projectDetails?.status);
  const [projectEdit, setProjectEdit] = useState(false);
  const [projectName, setProjectName] = useState();
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [projectType, setProjectType] = useState(
    projectDetails?.quotation_type?.id
  );
  const [projectCoordinator, setProjectCoordinator] = useState();
  const [reportingManager, setReportingManager] = useState();
  const nodeToken = localStorage.getItem("nodeToken");
  const [visaCount,setVisacount] = useState()
  const visaData = async () => {
    if (!projectDetails?.id) {
      console.log("No projectDetails.id available, skipping visaData fetch.");
      return;
    }
    try {
      const response = await nodeinstance.get(
        `/dashboard/projects/getVisadetailsforproject/${projectDetails?.id}`,
        {
          headers: { Authorization: `Bearer ${nodeToken}` },
        }
      );
      if(response.status === 200){
        setVisacount(response?.data?.data)
      }
   
    } catch (error) {
      dispatch(
        setAppError({
          msg: "something went wrong....",
        })
      );
    }
  };
console.log("visaCount.....",visaCount)
  useEffect(() => {
    setIntialState({
      projectName: projectDetails?.name,
      projectType: projectDetails?.quotation_type?.id,
      projectCoordinator: projectDetails?.project_coordinator_id || "",
      reportingManager: projectDetails?.reporting_manager_id || "",
    });
    setProjectName(projectDetails?.name);
    setProjectType(projectDetails?.quotation_type?.id);
    setProjectCoordinator(projectDetails?.project_coordinator_id);
    setReportingManager(projectDetails?.reporting_manager_id);
    visaData();
  }, [projectDetails]);

  const submitProjectEdit = async (e) => {
    setLoadingSubmit(true);
    e.preventDefault();
    if (
      initialState?.projectName !== projectName ||
      initialState?.projectType !== projectType ||
      initialState?.projectCoordinator !== projectCoordinator ||
      initialState?.reportingManager !== reportingManager
    ) {
      try {
        let body = {
          name: projectName,
          quotation_type_id: projectType,
          project_coordinator_id: projectCoordinator,
          reporting_manager_id: reportingManager,
        };
        const response = await axios.put(
          `/dashboard/project/${projectDetails?.id}`,
          body,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(response);
        toggleProjectUpdate();
        setLoadingSubmit(false);
        dispatch(
          setAppError({
            msg: "Successfully edited.",
            color: "success",
          })
        );
        setProjectEdit(false);
      } catch (error) {
        setLoadingSubmit(false);
        dispatch(
          setAppError({
            msg: error?.response?.data?.message,
          })
        );
      }
    } else {
      setProjectEdit(false);
      setLoadingSubmit(false);
    }
  };

  // const allStatus = [
  //   "In Progress",
  //   "Not Started",
  //   "On hold",
  //   "Cancelled",
  //   "Finished",
  // ];

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  return (
    <div className="p-6 max-w-4xl">

      {/* Edit button */}
      {!projectEdit && checkAccess("Project", "project-edit") && (
        <div className="flex justify-end mb-4">
          <button
            className="flex items-center gap-2 border border-slate-300 px-4 py-2 rounded-md hover:bg-slate-50 transition-colors"
            onClick={() => setProjectEdit(true)}
          >
            <CiEdit size={"1.1rem"} />
            <span>Edit</span>
          </button>
        </div>
      )}

      <form onSubmit={submitProjectEdit}>
        {/* Project Info Card */}
        <div className="bg-white border border-slate-200 rounded-lg p-6 mb-4">
          <h3 className="font-semibold text-slate-700 mb-4 uppercase tracking-wide border-b border-slate-100 pb-2">Project Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

            <div>
              <label className="block text-xs text-slate-500 mb-1 uppercase">Project Name</label>
              <textarea
                required
                className={`w-full font-medium bg-slate-50 rounded-md p-2 resize-none ${projectEdit ? "border border-slate-300 focus:outline-none focus:border-blue-400" : "border-none bg-transparent"}`}
                defaultValue={projectName}
                onChange={(e) => setProjectName(e.target.value)}
                disabled={!projectEdit}
                rows={2}
              />
            </div>

            <div>
              <label className="block text-xs text-slate-500 mb-1 uppercase">Client Name</label>
              <input
                type="text"
                className="w-full font-medium bg-transparent border-none p-2"
                defaultValue={projectDetails?.client?.name}
                disabled
              />
            </div>

            <div>
              <label className="block text-xs text-slate-500 mb-1 uppercase">Project Type</label>
              <select
                required
                value={projectType}
                disabled
                onChange={(e) => setProjectType(e.target.value)}
                className="w-full font-medium bg-transparent border-none p-2 opacity-100"
              >
                <option value="" hidden>Select an Option</option>
                {projectTypeArray?.map((type) => (
                  <option key={type?.id} value={type?.id}>{type?.name}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-xs text-slate-500 mb-1 uppercase">VISA Provider Name</label>
              <input
                type="text"
                className="w-full font-medium bg-transparent border-none p-2"
                defaultValue={projectDetails?.company?.name}
                disabled
              />
            </div>

            <div>
              <label className="block text-xs text-slate-500 mb-1 uppercase">Quotation Number</label>
              <input
                type="text"
                className="w-full font-medium bg-transparent border-none p-2"
                defaultValue={projectDetails?.quotation?.quotation_number}
                disabled
              />
            </div>

            <div>
              <label className="block text-xs text-slate-500 mb-1 uppercase">Contract Number</label>
              <input
                type="text"
                className="w-full font-medium bg-transparent border-none p-2"
                defaultValue={projectDetails?.contract?.contract_number}
                disabled
              />
            </div>

            <div>
              <label className="block text-xs text-slate-500 mb-1 uppercase">Assigned Project Coordinator</label>
              <select
                required
                value={projectCoordinator}
                disabled={!projectEdit}
                onChange={(e) => setProjectCoordinator(e.target.value)}
                className={`w-full font-medium bg-slate-50 rounded-md p-2 ${projectEdit ? "border border-slate-300 focus:outline-none" : "border-none bg-transparent opacity-100"}`}
              >
                <option value="" hidden>Select an Option</option>
                {projectCoordinatorArray?.map((c) => (
                  <option key={c?.id} value={c?.id}>{c?.name}</option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-xs text-slate-500 mb-1 uppercase">Reporting Manager</label>
              <select
                required
                value={reportingManager}
                disabled={!projectEdit}
                onChange={(e) => setReportingManager(e.target.value)}
                className={`w-full font-medium bg-slate-50 rounded-md p-2 ${projectEdit ? "border border-slate-300 focus:outline-none" : "border-none bg-transparent opacity-100"}`}
              >
                <option value="" hidden>Select an Option</option>
                {reportingManagerArray?.map((r) => (
                  <option key={r?.id} value={r?.id}>{r?.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Visa Stats Card */}
        <div className="bg-white border border-slate-200 rounded-lg p-6 mb-4">
          <h3 className="font-semibold text-slate-700 mb-4 uppercase tracking-wide border-b border-slate-100 pb-2">Visa Statistics</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-blue-50 rounded-lg p-4 text-center">
              <p className="text-xs text-slate-500 uppercase mb-1">Allocated Visas</p>
              <p className="text-2xl font-bold text-blue-600">{visaCount?.[0]?.total_allocated_visa ?? "—"}</p>
            </div>
            <div className="bg-green-50 rounded-lg p-4 text-center">
              <p className="text-xs text-slate-500 uppercase mb-1">Visa Stamped</p>
              <p className="text-2xl font-bold text-green-600">{visaCount?.[0]?.stamped_count ?? "—"}</p>
            </div>
            <div className="bg-orange-50 rounded-lg p-4 text-center">
              <p className="text-xs text-slate-500 uppercase mb-1">Balance Visas</p>
              <p className="text-2xl font-bold text-orange-600">{visaCount?.[0]?.balance ?? "—"}</p>
            </div>
          </div>
        </div>

        {/* Action buttons */}
        {projectEdit && (
          <div className="flex gap-3">
            <button
              type="button"
              className="border border-slate-300 px-6 py-2 rounded-md hover:bg-slate-50"
              onClick={() => {
                setProjectEdit(false);
                setProjectName(initialState?.projectName);
                setProjectType(initialState?.projectType);
                setProjectCoordinator(initialState?.projectCoordinator);
                setReportingManager(initialState?.reportingManager);
              }}
            >
              Cancel
            </button>
            <button type="submit" className="bg-red text-white px-6 py-2 rounded-md hover:opacity-90">
              {loadingSubmit ? <CgSpinner className="animate-spin mx-auto" /> : "Save Changes"}
            </button>
          </div>
        )}
      </form>
    </div>
  );
}
